import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "idle-logout-backdrop",
  role: "alertdialog",
  "aria-modal": "true"
};
const _hoisted_2 = {
  class: "idle-logout-card"
};
const _hoisted_3 = {
  class: "mb-2"
};
const _hoisted_4 = {
  class: "mb-3"
};
const _hoisted_5 = {
  class: "d-flex gap-2 justify-content-end flex-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.warningVisible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h5", _hoisted_3, _toDisplayString($options.policy.wording.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString($options.body), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-light",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.logout && $options.logout(...args))
  }, _toDisplayString($options.policy.wording.logout), 1), _createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.stay && $options.stay(...args))
  }, _toDisplayString($options.policy.wording.stay), 1)])])])) : _createCommentVNode("", true);
}